// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import Checkbox from '../Checkbox';

class OptionsSidebar extends Component {
  constructor(props) {
    super(props);

    this.isChecked = this.isChecked.bind(this);
  }

  isChecked(option) {
    const hasValue = option.value
    const value = hasValue && option.value.toString()
    const { activeItems } = this.props
    
    if (hasValue) {
      return activeItems.includes(value)
    }

    return activeItems.includes(option.title)
  }
  
  render() {
    const {
      handleButtonCloseClick,
      title,
      options,
      optionWithImage,
      activeItems,
      handleUpdateField,
    } = this.props;
    
    return ( 
      <div class="advanced-filter__options-sidebar options-sidebar">
        <div className="options-sidebar__header">
          <button
            className="options-sidebar__header-button-back button--close"
            onClick={handleButtonCloseClick}
          >
            <i className="icon icon-arrow-left" />
          </button>
          <h4 className="options-sidebar__header-title">{title}</h4>
        </div>

        <div className="options-sidebar__body">
          <ul className="options-sidebar__list-items">
            {options.length > 0 && options.map((option, index) => (
              <li
                key={`${option.title}-${option.count}-${index}`}
                className="filter-v2__checkbox-item"
                data-active={activeItems.includes(option.title)}
              >
                {optionWithImage ? (
                  <Checkbox
                    name={option.value || option.title}
                    imageUrl={option.logo || 'https://placehold.co/32x32'}
                    labelText={option.title}
                    handleChange={handleUpdateField}
                    checked={this.isChecked(option)}
                  />
                ) : (
                  <Checkbox
                    name={option.value || option.title}
                    labelText={option.title}
                    handleChange={handleUpdateField}
                    checked={this.isChecked(option)}
                  />
                ) }
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

OptionsSidebar.defaultProps = {
  handleButtonCloseClick: () => {},
  handleUpdateField: () => {},
  optionWithImage: false,
  options: [],
  activeItems: [],
  title: '',
};

OptionsSidebar.propTypes = {
  handleButtonCloseClick: PropTypes.func,
  handleUpdateField: PropTypes.func,
  optionWithImage: PropTypes.bool,
  options: PropTypes.arrayOf(),
  activeItems: PropTypes.arrayOf(),
  title: PropTypes.string,
};

export default OptionsSidebar;
